import styled from '@emotion/styled';
import { ModuleBadge } from 'components';

export const lrwSessionFormStyles = {
  TimePickersDiv: styled.div`
    display: flex;
    align-items: baseline;
    gap: 1rem;
  `,
  ModuleBadge: styled(ModuleBadge)`
    &.ui.label {
      position: absolute;
      right: 1rem;
    }
  `,
  CheckboxWithCustomLabel: styled.div`
    display: inline-flex;
    align-items: center;
    margin-right: 1rem;

    .ui.checkbox {
      margin-right: 0.5rem;
    }

    label {
      cursor: pointer;
    }

    .ui.label {
      cursor: pointer;
    }

    .ui.checkbox.disabled ~ label {
      cursor: not-allowed;
      opacity: 0.3;
    }

    .ui.checkbox.disabled ~ label .ui.label {
      cursor: not-allowed;
      opacity: 0.3;
    }
  `,
  FieldGroupLabel: styled.div`
    font-weight: 700;
    font-size: 13px;
    margin-bottom: 4px;
  `,
};
